import {accountType, inherentRiskType, controlRiskType, riskType, taskStatus} from './Constants';

export const getAccountTypeName = (accountTypeId) => {
	return accountType.find((x) => x.id === accountTypeId)?.label;
};

export const getInherentRiskTypeName = (inherentRiskTypeId) => {
	return inherentRiskType.find((x) => x.id === inherentRiskTypeId)?.label;
};

export const getControlRiskTypeName = (controlRiskTypeId) => {
	return controlRiskType.find((x) => x.id === controlRiskTypeId)?.label;
};

export const getRiskTypeName = (riskTypeId) => {
	return riskType.find((x) => x.id === riskTypeId)?.label;
};

export const getTaskStatusName = (taskStatusId) => {
	return taskStatus.find((x) => x.id === taskStatusId)?.label;
};
